var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagHungary(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlagHungary_svg__a",
    width: 40,
    height: 40,
    x: 4,
    y: 4,
    rx: 6.667
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlagHungary_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlagHungary_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#D8D8D8",
    xlinkHref: "#FlagHungary_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlagHungary_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#BC0030",
    d: "M-12 44.114h70.484V2.998H-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M-12 44.114h70.484V16.707H-12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3D9348",
    d: "M-12 44.114h70.484V30.405H-12z"
  })))));
}
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0iaTg2NmdsY2xhYSIgd2lkdGg9IjQwIiBoZWlnaHQ9IjQwIiB4PSI0IiB5PSI0IiByeD0iNi42NjciLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPGc+CiAgICAgICAgICAgIDxtYXNrIGlkPSJ1NW9wOXE4cDliIiBmaWxsPSIjZmZmIj4KICAgICAgICAgICAgICAgIDx1c2UgeGxpbms6aHJlZj0iI2k4NjZnbGNsYWEiLz4KICAgICAgICAgICAgPC9tYXNrPgogICAgICAgICAgICA8dXNlIGZpbGw9IiNEOEQ4RDgiIHhsaW5rOmhyZWY9IiNpODY2Z2xjbGFhIi8+CiAgICAgICAgICAgIDxnIG1hc2s9InVybCgjdTVvcDlxOHA5YikiPgogICAgICAgICAgICAgICAgPGc+CiAgICAgICAgICAgICAgICAgICAgPHBhdGggZmlsbD0iI0JDMDAzMCIgZD0iTTAgNDEuMTE0TDcwLjQ4NCA0MS4xMTQgNzAuNDg0IC0wLjAwMiAwIC0wLjAwMnoiIHRyYW5zZm9ybT0idHJhbnNsYXRlKC0xMiAzKSIvPgogICAgICAgICAgICAgICAgICAgIDxwYXRoIGZpbGw9IiNGRkYiIGQ9Ik0wIDQxLjExNEw3MC40ODQgNDEuMTE0IDcwLjQ4NCAxMy43MDcgMCAxMy43MDd6IiB0cmFuc2Zvcm09InRyYW5zbGF0ZSgtMTIgMykiLz4KICAgICAgICAgICAgICAgICAgICA8cGF0aCBmaWxsPSIjM0Q5MzQ4IiBkPSJNMCA0MS4xMTRMNzAuNDg0IDQxLjExNCA3MC40ODQgMjcuNDA1IDAgMjcuNDA1eiIgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoLTEyIDMpIi8+CiAgICAgICAgICAgICAgICA8L2c+CiAgICAgICAgICAgIDwvZz4KICAgICAgICA8L2c+CiAgICA8L2c+Cjwvc3ZnPgo=";
export { SvgFlagHungary as ReactComponent };